import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config/api';
import siteContentStatic from '../data/siteContent.json';

function ReglesDeVie() {
  const [data, setData] = useState(siteContentStatic.rules);

  useEffect(() => {
    fetch(`${API_BASE}/api/site-content`)
      .then(res => { if (!res.ok) throw new Error(); return res.json(); })
      .then(content => { if (content.rules) setData(content.rules); })
      .catch(() => {});
  }, []);

  return (
    <article className="page type-page status-publish hentry">
      <header className="entry-header">
        <h1 className="entry-title">{data.title}</h1>
      </header>

      <div className="entry-content">
        <p dangerouslySetInnerHTML={{ __html: data.intro }} />

        <ul>
          {data.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>

        {data.image && (
          <div className="page-image-showcase">
            <img
              src={data.image}
              alt="La vie à RIVE"
              loading="lazy"
            />
          </div>
        )}
      </div>
    </article>
  );
}

export default ReglesDeVie;
